"use client"

import { DropdownMenuItem } from "@/components/ui/dropdown-menu"
import { logoutUser } from "@/lib/api/users"
import { usePrivy } from "@privy-io/react-auth"

export default function LogoutButton() {
  const privy = usePrivy()

  return (
    <DropdownMenuItem
      className="cursor-pointer"
      onClick={async () => {
        await Promise.all([privy.logout(), await logoutUser()])

        window.location.href = "/"
      }}
    >
      Logout
    </DropdownMenuItem>
  )
}
